import {
  DocumentOrganizationKeys,
  FilterOptionKeys,
  Goal,
  GoalFilterDocument,
  GoalSortingMode,
  GroupByMode,
  LifeArea,
  LocalizedLifeArea,
} from '@griply/types';

export const getLifeAreaGoalFilterDocument = (
  lifeArea: LifeArea | LocalizedLifeArea | undefined,
  goals: Goal[],
): GoalFilterDocument => {
  const base: GoalFilterDocument = lifeArea?.goalFilterDocument ?? {
    [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  };

  return {
    ...base,
    [DocumentOrganizationKeys.GroupByMode]:
      base.groupByMode ?? GroupByMode.None,
    [DocumentOrganizationKeys.SortingMode]:
      base.sortingMode ??
      lifeArea?.goalSortingMode ??
      GoalSortingMode.StartDate,
    [DocumentOrganizationKeys.Filters]: {
      ...(base[DocumentOrganizationKeys.Filters] ?? {}),
      [FilterOptionKeys.LifeArea]: {
        include: [lifeArea?.id ?? ''],
      },
    },
    [DocumentOrganizationKeys.CollapsedSections]:
      base.collapsedSections ??
      lifeArea?.collapsedGoals ??
      goals.map(({ id }) => id),
  };
};
